import { PublicScansPage } from '../PublicScansPage.js';

export default function ScannerPage() {
  const im = (import.meta as unknown as { env?: { VITE_REGISTRY_URL?: string } }) || {};
  const reg = im.env?.VITE_REGISTRY_URL || 'http://localhost:3410';
  return <PublicScansPage registryUrl={String(reg)} />;
}
